export default __webpack_public_path__ + "static/media/Smlouva a Všeobecné Obchodní Podmínky v platnosti od 21.4.2020 - Depot Prague Malešice.58f80589.pdf";